import { ChevronRightIcon } from '@grupoboticario/flora-react-icons';
import { user, type SubmenuBase } from 'core';
import { formatString, getSupervisorInfo, getWhatsAppLink } from 'core/utilities';
import { NavBarList, Tag } from 'ui/components';

import { useResize } from '../../../hooks';
import { getEventLabel, getFallbackToLink } from '../helpers';
import { useHandleTrackClick } from '../hooks';
import { componentsMapper } from './components-mapper';
import { HeaderStyles } from './NavDropDown.styles';

const NavDropdown = ({
  links = [],
  title = '',
  linkLength,
  component,
}: SubmenuBase & {
  linkLength: number;
}) => {
  const {
    data: {
      supervisor,
      isMultiBrand,
      cycle: { currentCycle },
    },
  } = user.hooks.useUser();
  const { handleTrackClick } = useHandleTrackClick();
  const [isMobile] = useResize();
  const { supervisorName, supervisorEmail, supervisorPhone } = getSupervisorInfo(supervisor);

  if (component) {
    const Component = componentsMapper[component];

    return <Component />;
  }

  return (
    <NavBarList.Content>
      <NavBarList.Title>{formatString(title, { supervisorName })}</NavBarList.Title>
      <NavBarList.Component data-columns={linkLength}>
        {links?.map((item) => {
          const isWhatsappButton = item.description?.includes('MOBILE_PHONE_SUPERVISOR') || false;
          const labelMenu = isMultiBrand && item?.textMultiBrand ? item.textMultiBrand : item?.text;
          const eventLabel = getEventLabel(labelMenu, item?.showTagNewFeature || false);
          const to = getFallbackToLink(item, isMultiBrand, currentCycle);

          return (
            <NavBarList.DropdownCard radius="rounded" key={`navbarcard-${labelMenu}`}>
              <NavBarList.CardInfo
                to={isWhatsappButton ? getWhatsAppLink(supervisorPhone, isMobile) : to}
                data-link={item.isLink}
                data-label={isWhatsappButton ? 'whatsapp' : labelMenu}
                data-event={isWhatsappButton ? 'whatsapp' : eventLabel}
                onClick={(event: UIEvent) => {
                  handleTrackClick(event, true);
                }}
              >
                <NavBarList.Text>
                  <HeaderStyles.TagNewFeatWrapper>
                    <span> {labelMenu}</span>
                    {item.showTagNewFeature && <Tag variant="reward">NOVO</Tag>}
                  </HeaderStyles.TagNewFeatWrapper>

                  <small>
                    {formatString(item.description, { supervisorPhone, supervisorEmail })}
                  </small>
                </NavBarList.Text>

                {item.isLink && (
                  <NavBarList.Svg aria-hidden={true}>
                    <ChevronRightIcon />
                  </NavBarList.Svg>
                )}
              </NavBarList.CardInfo>
            </NavBarList.DropdownCard>
          );
        })}
      </NavBarList.Component>
    </NavBarList.Content>
  );
};

export default NavDropdown;
